<template>
  <div class="home" :class="{'clicked-once':firstClick}">
    <side-nav :isMobile="$parent.isMobile" :number="selected_button" :sideNavActive="sideNavActive"></side-nav>
    <div class="logo-corian">
      <picture>
        <img :src="'img/corian-solid-surface-logo.svg'">
      </picture>
    </div>
    <div class="interactive-picture__switch-button" @click.prevent="light_version=!light_version">
      <div class="rounded-background">
        <div class="rounded-foreground" :class="{active:!light_version}">
          <svg width="36px" height="35px">
            <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                  d="M17.708,-0.000 C27.488,-0.000 35.417,7.835 35.417,17.500 C35.417,27.165 27.488,35.000 17.708,35.000 C7.928,35.000 0.000,27.165 0.000,17.500 C0.000,7.835 7.928,-0.000 17.708,-0.000 Z"/>
            <path fill-rule="evenodd" fill="rgb(49, 56, 59)"
                  d="M27.860,18.340 L25.130,21.069 L25.130,25.653 C25.130,25.917 24.915,26.131 24.651,26.131 L20.069,26.131 L17.339,28.860 C17.245,28.953 17.123,29.000 17.000,29.000 C16.878,29.000 16.755,28.954 16.662,28.860 L13.932,26.131 L9.347,26.131 C9.083,26.131 8.869,25.917 8.869,25.653 L8.869,21.069 L6.139,18.340 C5.952,18.154 5.952,17.851 6.139,17.664 L8.869,14.935 L8.869,10.351 C8.869,10.087 9.083,9.873 9.347,9.873 L13.932,9.873 L16.658,7.147 C16.746,7.056 16.868,7.000 17.003,7.000 C17.260,7.000 17.303,7.000 20.173,9.873 L24.651,9.873 C24.915,9.873 25.130,10.087 25.130,10.351 L25.130,14.881 C26.691,16.470 27.863,17.667 27.863,17.667 C28.046,17.855 28.044,18.155 27.860,18.340 ZM16.999,10.829 C13.043,10.829 9.825,14.046 9.825,18.002 C9.825,21.957 13.043,25.175 16.999,25.175 C20.955,25.175 24.173,21.957 24.173,18.002 C24.173,14.046 20.955,10.829 16.999,10.829 ZM16.999,24.218 C13.571,24.218 10.782,21.429 10.782,18.002 C10.782,14.574 13.571,11.786 16.999,11.786 C20.427,11.786 23.217,14.574 23.217,18.002 C23.217,21.429 20.427,24.218 16.999,24.218 ZM17.478,14.177 C17.478,13.913 17.263,13.698 16.999,13.698 C14.626,13.698 12.695,15.629 12.695,18.002 C12.695,20.375 14.626,22.305 16.999,22.305 C17.263,22.305 17.478,22.091 17.478,21.827 L17.478,14.177 Z"/>
          </svg>
        </div>
        <svg width="70px" height="38px">
          <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="2px" stroke-linecap="butt"
                stroke-linejoin="miter" fill="rgb(200, 200, 200)"
                d="M18.917,1.000 L50.500,1.000 C60.165,1.000 68.000,8.835 68.000,18.500 C68.000,28.165 60.165,36.000 50.500,36.000 L18.917,36.000 C9.252,36.000 1.417,28.165 1.417,18.500 C1.417,8.835 9.252,1.000 18.917,1.000 Z"/>
        </svg>
      </div>
    </div>
    <div class="interactive-picture">
      <div class="interactive-picture__child">
        <Button :selected_button.sync="selected_button" v-for="item in button" :number="item.id"
                :posX="item.posX" :posY="item.posY" :active="item.active">{{ item.id }}
        </Button>
        <div @click="clickOuter($event)" class="interactive-picture__img">
          <transition name="fade" mode="out-in">
            <picture v-if="light_version" key="light">
              <source media="(max-width: 736px)" :srcset="'img/main-background-picture@0,5x.jpg'">
              <img :src="'img/main-background-picture.jpg'">
            </picture>
            <picture v-else key="dark">
              <source media="(max-width: 736px)" :srcset="'img/main-background-picture-dark@0,5x.jpg'">
              <img :src="'img/main-background-picture-dark.jpg'">
            </picture>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideNav from './SideNav.vue';
import Button from './Button.vue';
import TweenMax from "gsap";
import ThrowPropsPlugin from "../assets/js/plugins/ThrowPropsPlugin";
import Draggable from "gsap/Draggable";

let $selectedNumber = 0;
export default {
  beforeRouteEnter(to, from, next) {
    if (from.params.number) $selectedNumber = from.params.number;
    next()
  },
  beforeRouteLeave(to, from, next) {
    window.sessionStorage.setItem('light_version', this.light_version);
    next()
  },
  name: 'home',
  components: {Button, SideNav},
  created() {
    if ($selectedNumber > 0) {
      this.selected_button = $selectedNumber;
      $selectedNumber = 0;
    }
    this.resetArrayNumbers(this.$parent.isMobile);
  },
  mounted() {
    Draggable.create(".interactive-picture__child",
        {type: "x", edgeResistance: 1.25, bounds: '.main', throwProps: true});
    let _this = this;
    setTimeout(function () {
      const hashURL = document.location.hash;
      if (hashURL.match(/ui=/)) {
        if (/ui=(\w+)/.exec(hashURL)[1] === 'dark') _this.light_version = false;
        if (/ui=(\w+)/.exec(hashURL)[1] === 'light' || /ui=(\w+)/.exec(hashURL)[1] === '') _this.light_version = true;
      } else {
        if (typeof window.sessionStorage.getItem('light_version') === 'string') {
          _this.light_version = JSON.parse(window.sessionStorage.getItem('light_version'))
        } else {
          _this.light_version = true;
        }
      }
    }, 0)
  },
  data() {
    return {
      button: this.$appConfig.numbers,
      selected_button: 0,
      firstClick: false,
      sideNavActive: false,
      light_version: ''
    }
  },
  methods: {
    resetArrayNumbers(isMobile) {
      if (isMobile) {
        this.button = this.button.map((item) => {
          let newPosX = (item.posX / 2) - 10;
          let newPosY = (item.posY / 2) - 10;
          return {"id": item.id, "active": false, "posX": newPosX, "posY": newPosY}
        });
      } else {
        this.button = this.$appConfig.numbers
      }
    },
    clickOuter(event) {
      let _this = this;
      if (event.target.classList.contains('interactive-picture__img')) {
        const sideNav = document.querySelector('.side-nav');
        if (sideNav.classList.contains('active')) sideNav.classList.remove('active');
        this.firstClick = false;
        this.selected_button = 0;
        this.button.forEach((btn) => btn.active = false)
      }
    }
  },
  watch: {
    '$parent.isMobile'(isMobile) {
      this.resetArrayNumbers(isMobile)
    },
    selected_button(value) {
        this.sideNavActive = value;
      if (value) {
        this.firstClick = true;
      }
      this.button.forEach((btn) => {
        btn.active = (+btn.id === +this.selected_button)
      })
    }
  }
}
</script>

<style>
.interactive-picture__switch-button {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
}
.rounded-background {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 5;
}
.rounded-foreground {
  top: 0;
  left: 0;
  position: absolute;
  filter: drop-shadow(3px 0 1px rgba(0, 0, 0, .25));
}
.rounded-foreground.active {
  left: auto;
  right: 0;
  filter: drop-shadow(-3px 0 1px rgba(0, 0, 0, .25));
}
</style>